<template>
    <div class="classBox">
        <div class="box_list" v-for="item in 20" :key="item" @click="switchDetailsFn(item)">
            <!-- <img src="../../../assets/Bj_background.png" alt=""> -->
            <p class="box_text box_text1" style="">1111</p>
            <div class="box_text box_text2 displaybetween">
                <ul>
                    <li class="LabelBox">xxx</li>
                </ul>
                <span style="color: #999;font-size: 14px;">共1节</span>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'classBox',
    components: {  },
    data() {
        return {
        }
    },
    created() { },
    mounted() { },
    methods: {
        switchDetailsFn(item = {}) {
            this.$router.push('classDetails')
        },
    }
}
</script>
<style lang='scss' scoped>

</style>
